<template>
    <div>
        <vue-html2pdf
      :show-layout="false"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1200"
      :filename="'Relatorio Despesas Viagem ' + dataFormatada"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      :pdf-margin="10"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @beforeDownload="abrirNovaGuia"
      ref="html2Pdf">
    <!-- `detailsProp` nasce [] e so e populado no gerarPDF do pai. Sem este v-if o template
         le detailsProp[0].nome no PRIMEIRO render e estoura (ZC-40) -- este erro sim aparece
         sempre, porque o componente monta junto com a tela.
         Seguro com `manual-pagination="true"`: os dois `null.firstChild` do vue-html2pdf
         (paginationOfElements / resetPagination) sao inalcancaveis nesse modo. Pior caso com
         detailsProp vazio e PDF em branco, nao excecao. -->
    <section slot="pdf-content" v-if="detailsProp && detailsProp.length">
        <div class="conteiner_pdf_grafico">
            <div class="pdf-header">
                <div class="nome_relatorio-pdf">
                    Relatório Despesas Viagem  - {{ ' ' + dataFormatada}}
                </div>
            </div>
        </div>
        <div class="filtro_parametros-pdf">
         <div class="report-filter">
                <div class="filtro_parametros-peq">
                    <div class="container_header_filtro_periodo_atividade">
                        <div class="status_filtro">
                            <div class=" d-flex">
                                <div class="border-filter">
                                    <i class="fas fa-user icon-filter d- mr-2 ml-2"></i>
                                </div>
                                <div style="display: flex; flex-direction: column;">
                                    <div>
                                        Funcionário:  <strong class="filtrostatus">{{detailsProp[0].nome}}</strong>
                                    </div>
                                    <div>
                                        Matrícula:  <strong class="filtrostatus">{{ detailsProp[0].matricula }} </strong>
                                    </div>
                                    <div v-if="detailsProp[0].cpf !== null || detailsProp[0].rg !== null">
                                        <div v-if="detailsProp[0].cpf !== null">
                                            CPF:  <strong class="filtrostatus">{{ detailsProp[0].cpf }} </strong>
                                        </div>
                                        <div v-if="detailsProp[0].rg !== null && detailsProp[0].cpf === null">
                                            RG:  <strong class="filtrostatus">{{ detailsProp[0].rg }} </strong>
                                        </div>
                                    </div>
                                    <div>
                                        Cargo:  <strong class="filtrostatus">{{ detailsProp[0].funcao }} </strong>
                                    </div>
                                    <div>
                                        Situação:  <strong class="filtrostatus">{{ detailsProp[0].desligado == null ? 'Ativo' : 'Desligado'}} </strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="report-qta">
                    <div class="numerochamados">
                        <div class="qtachamado">
                            {{detailsProp[0].detalhes.length == null ? 0 : detailsProp[0].detalhes.length }}
                            </div>
                            <div class="text-filter">
                                Total de Lotes
                            </div>
                    </div>
                    <div class="numerochamados">
                        <div class="qtachamado">
                            {{detailsProp[0].valorTotalGastosFuncionario == null ? 0 : formatMoney(detailsProp[0].valorTotalGastosFuncionario) }}
                        </div>
                        <div class="text-filter">
                            Total Gasto nos Lotes
                        </div>
                    </div>
                </div>
            </div>
            <div class="container_pdffiltro">
                <div class="container_ocorrencias_filtradas">
                    <div class="lote_pdf font">Lote</div>
                    <div class="lote_pdf font">Pedidos</div>
                    <div class="area_apr font">Obra</div>
                    <div class="responsavel_apr font">Início Viagem</div>
                    <div class="dataInicio_apr font">Fim Viagem</div>
                    <div class="dataInicio_apr font">Adiantamento</div>
                    <div class="dataFim_apr font">Total Gasto</div>
                </div>
                <div class="container_ocorrencias" v-for=" obj in detailsProp[0].detalhes" :key="obj.id">
                    <div class="lote_pdf_result font_result">{{obj.lote  !== null ? obj.lote : 'N/D'}}</div>
                    <div class="lote_pdf_result font_result">{{obj.pedido  !== null ? obj.pedido : 'N/D'}}</div>
                    <div class="area_apr_result font_result">{{obj.obra !== null ? obj.obra : 'N/D'}}</div>
                    <div class="responsavel_apr_result font_result">{{ obj.dataInicioViagem !== null ? obj.dataInicioViagem : 'N/D' }}</div>
                    <div class="dataInicio_apr_result font_result">{{obj.dataFimViagem !== null ? obj.dataFimViagem : 'N/D'}}</div>
                    <div class="dataInicio_apr_result font_result">{{obj.valorAdiantamento !== null ? formatMoney(obj.valorAdiantamento) : 'N/D' }}</div>
                    <div class="dataFim_apr_result font_result">{{obj.valorTotalGastos !== null  ? formatMoney(obj.valorTotalGastos) : 'N/D' }}</div>
                </div>
            </div>
        </div>
    </section>
    </vue-html2pdf>
    </div>
</template>

<script>

import ActionsForm from '@/shared/mixins/actionsForm'
import VueHtml2pdf from 'vue-html2pdf'
import cabecalhoPng from '../../../../../../../../../../../../static/img/realestate/relatorio/cabecalho.png'
import Tools from '@/components/tools/Tools'

export default {
  name: 'aprReportTable',
  components: {VueHtml2pdf},
  mixins: [ActionsForm],
  props: ['detailsProp'],
  data () {
    return {
      dataFormatada: null,
      filtros: {},
      quantitativos: {},
      dados: []
    }
  },
  computed: {
    nomeArquivo () {
      return `Relatorio LOTE - ${this.dataFormatada}`
    }
  },
  mounted () {
    this.dataFormatadaPdf()
    this.groupedData()
    console.log(this.detailsProp)
  },
  methods: {
    groupedData () {
      let chunks = []
      for (let i = 0; i < this.dados.length; i += 15) {
        chunks.push(this.dados.slice(i, i + 15))
      }
      return chunks
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    dataFormatadaPdf () {
      var dataAtual = new Date()
      var ano = dataAtual.getFullYear()
      var mes = ('0' + (dataAtual.getMonth() + 1)).slice(-2)
      var dia = ('0' + dataAtual.getDate()).slice(-2)
      this.dataFormatada = dia + '/' + mes + '/' + ano
    },
    createImageHeaderFooter (imgHref) {
      const img = document.createElement('img')
      img.src = imgHref
      img.style.border = 'none'
      return img
    },
    generatePDF () {
      this.$refs.html2Pdf.generatePdf()
    },
    async abrirNovaGuia ({ html2pdf, options, pdfContent }) {
      const headerImage = new URL(cabecalhoPng, window.location.origin)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)
      options.margin = [1.5, 0, 0.5, 0]
      html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.addImage(headerPdf, 'PNG', 0, 0, 8.5, 0)
          pdf.setPage(i)
          pdf.setFillColor(28, 98, 40)
          pdf.rect(0, pdf.internal.pageSize.getHeight() - 0.4, pdf.internal.pageSize.getWidth(), 10, 'F')
          pdf.setTextColor('#fff')
          pdf.setFont('Helvetica', 'normal')
          pdf.setFontSize(10)
          pdf.setFont('Helvetica', 'bold')
          pdf.text('Zopone - ', 0.3, pdf.internal.pageSize.getHeight() - 0.15)
          pdf.text(
            ' Relatório Despesas Viagem  - ' + this.dataFormatada,
            0.90,
            pdf.internal.pageSize.getHeight() - 0.15
          )
          pdf.setFont('Helvetica', 'normal')
          pdf.text(
            'Pág ',
            7,
            pdf.internal.pageSize.getHeight() - 0.15
          )
          pdf.setFont('Helvetica', 'bold')
          pdf.text(
            i + ' de ' + totalPages,
            7.3,
            pdf.internal.pageSize.getHeight() - 0.15
          )
        }
      }).save()
    }
  }
}

</script>

<style scoped>

.conteiner_pdf_grafico{
    padding: 0.5rem;
}
.filtro_parametros-pdf{
    width: 100%;
    padding: 0.5rem;
    height: fit-content;
    border-radius: 5px;
}
.pdf-header{
    margin-bottom: 0.5rem;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.nome_relatorio-pdf {
    display: flex;
    width: 100%;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    color: rgb(54, 54, 54);
    font-family:'Poppins';
    margin-bottom: 1rem;
    background: transparent;
}
.report-filter{
    padding: 0.5rem;
    display: flex;
    gap: 1rem;
}
.filtro_parametros-peq{
    width: 100%;
    border-radius: 10px;
    background: #F4F4F4;
}
.filter-text{
    display:flex;
    align-items: center;
    padding: 1rem 0 0 1rem;
}
.border-filter{
    border-radius: 5px;
    background: #E8E8E8;
    width: 23px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right:1rem;
}
.icon-filter{
    color:#2E973D;
}
.header_filtro{
    color: #1A1818;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    font-family: 'Poppins';
}
.container_header_filtro_periodo_atividade{
    display: flex;
    padding: 1rem;
    gap: 1rem;
}
.status_filtro {
    color: #1A1818;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    font-family: 'Poppins';
}
.periodo_filtro {
    color: #1A1818;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
    font-family: 'Poppins';
}
.container_header_filtro{
    display: flex;
    padding: 0 1rem 0 1rem;
    flex-direction: column;
    gap: 1rem;
}
.header_filtro{
    color: #1A1818;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    font-family: 'Poppins';
}
.filtro_parametros{
    margin-top: 2rem;
    width: 100%;
    height: fit-content;
    background: rgb(236, 236, 236);
    border-radius: 5px;
    padding: 0.5rem
}
.report-qta{
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}
.numerochamados{
    width: 215px;
    height: 6rem;
    border-radius: 10px;
    background: #F4F4F4;
    padding: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.qtachamado{
    color: #008148;
    text-align: center;
    font-family: 'Poppins';
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 27px;
}
.text-filter{
    color: #1A1818;
    text-align: center;
    font-family: 'Poppins';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
}
.text-filter-small{
    color: #1A1818;
    text-align: center;
    font-family: 'Poppins';
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
}
.container_pdffiltro{
    margin-top: 2rem;
    width: 100%;
    padding: 1rem;
    border-radius: 10px;
}
.container_ocorrencias_filtradas{
    width: 100%;
    height: 2rem;
    border-radius: 5px 5px 0 0;
    background: #2E973D;
    display: flex;
    justify-content: space-around;
    align-items: center;
    break-before: avoid;
}
.container_ocorrencias_filtradas > div {
    width: calc(20% - 10px);
}
.container_ocorrencias_filtradas > .lote_pdf, .lote_pdf_result   {
    margin: 5px;
}
.container_ocorrencias_filtradas > .area_apr, .area_apr_result   {
    display: flex;
    justify-content: center;
    margin: 5px;
}
.container_ocorrencias_filtradas > .dataFim_apr, .dataFim_apr_result   {
    display: flex;
    justify-content: center;
    margin: 5px;
}
.container_ocorrencias_filtradas > .dataInicio_apr, .dataInicio_apr_result   {
    display: flex;
    justify-content: center;
    margin: 5px;
}
.container_ocorrencias_filtradas > .responsavel_apr, .responsavel_apr_result   {
    display: flex;
    justify-content: center;
    margin: 5px;
}
.container_ocorrencias_filtradas >
.descricao_oce_result,
.descricao_oce {
    width: 60% !important;
    margin: 5px;
}
.container_ocorrencias_filtradas,
.enterprise-report,
.container_ocorrencias_filtradas,
.container_ocorrencias,
.dataFim_apr_result
.dataInicio_apr_result
.responsavel_apr_result
.area_apr_result
.lote_pdf_result
{
    break-inside: avoid;
}
.container_ocorrencias {
    width: 100%;
    display: flex;
    justify-content: center;
    border: #f4f4f4 1px solid
}
.container_ocorrencias > div {
    width: calc(20% - 10px);
    margin: 5px;
}

.font{
    color: #FFF;
    font-family: 'Poppins';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px;
}
.lote_pdf {
    display: flex;
    justify-content: center;
    align-items: center;
}
.container_ocorrencias > .lote_pdf,
.lote_pdf_result {
    display: flex;
    justify-content: center;
    margin: 5px;
}
.font{
        color: #FFF;
        font-family: 'Poppins';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .font_result{
        color: #1A1818;
        font-family:'Poppins';
        text-align: center;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }

</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/Tabs/CollaboratorTableTravelExpense/components/CollaboratorTableTravelExpenseEmploye/components/reportLotsPdf.vue